// Device-local record of which Wellness topics a visitor has explored (no sign-in).
const KEY = "amd-wellness-read";

export function getRead() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function isRead(slug) {
  return getRead().includes(slug);
}

export function toggleRead(slug) {
  const list = getRead();
  const next = list.includes(slug) ? list.filter((s) => s !== slug) : [...list, slug];
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function markRead(slug) {
  const list = getRead();
  if (list.includes(slug)) return list;
  const next = [...list, slug];
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

export function clearRead() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return [];
}

// Stable, device-local certificate ID (format: AMD-WELL-XXXXXX).
const CERT_KEY = "amd-wellness-cert-id";

export function getCertId() {
  try {
    let id = localStorage.getItem(CERT_KEY);
    if (!id) {
      id = "AMD-WELL-" + Math.random().toString(36).slice(2, 8).toUpperCase();
      localStorage.setItem(CERT_KEY, id);
    }
    return id;
  } catch {
    return "AMD-WELL-000000";
  }
}

// Tracks distinct days a visitor returns, for a "return streak" reward.
const VISITS_KEY = "amd-wellness-visits";
const DAY_MS = 86400000;
const dayKey = (d) => d.toISOString().slice(0, 10);

export function recordVisit() {
  try {
    const today = dayKey(new Date());
    const raw = localStorage.getItem(VISITS_KEY);
    let days = raw ? JSON.parse(raw) : [];
    if (!days.includes(today)) {
      days = [...days, today].slice(-120);
      localStorage.setItem(VISITS_KEY, JSON.stringify(days));
    }
    return days;
  } catch {
    return [];
  }
}

export function getStreak() {
  try {
    const raw = localStorage.getItem(VISITS_KEY);
    const days = (raw ? JSON.parse(raw) : []).slice().sort();
    if (!days.length) return { current: 0, best: 0, total: 0 };
    const set = new Set(days);
    let current = 0;
    let cursor = new Date();
    while (set.has(dayKey(cursor))) {
      current++;
      cursor = new Date(cursor.getTime() - DAY_MS);
    }
    let best = 0, run = 0, prev = null;
    for (const d of days) {
      run = prev && new Date(d) - new Date(prev) === DAY_MS ? run + 1 : 1;
      best = Math.max(best, run);
      prev = d;
    }
    return { current, best, total: days.length };
  } catch {
    return { current: 0, best: 0, total: 0 };
  }
}
